export default __webpack_public_path__ + "static/media/TikTok_CopyData_Final.d3bc3238.jpeg";